import { render, staticRenderFns } from "./DiscardChanges.vue?vue&type=template&id=3627a149&scoped=true&"
import script from "./DiscardChanges.vue?vue&type=script&lang=js&"
export * from "./DiscardChanges.vue?vue&type=script&lang=js&"
import style0 from "./DiscardChanges.vue?vue&type=style&index=0&id=3627a149&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627a149",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3627a149')) {
      api.createRecord('3627a149', component.options)
    } else {
      api.reload('3627a149', component.options)
    }
    module.hot.accept("./DiscardChanges.vue?vue&type=template&id=3627a149&scoped=true&", function () {
      api.rerender('3627a149', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/edit/DiscardChanges.vue"
export default component.exports